const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = 1;
    script.onerror = () => reject(new Error(`FAILED TO LOAD SCRIPT: ${src}`));
    script.onload = resolve;

    document.body.appendChild(script);
  });

export default loadScript;
